<template>
  <ErrorMessage
    :displayLang="$i18n.locale"
    :typeOfMessage="code"
    :message="$t('errors.' + code)"
    :contactUsMessage="'contactina'"
    :politeForm="$t('errors.politeForm' + code) + '...'"
    :showDialog="showErrorMessage"
    v-on:hide-Message="handleMessageClose"
  />
</template>
<script>
import ErrorMessage from "@supervision/vue-components/components/ErrorMessage.vue";

export default {
  components: {
    ErrorMessage,
  },
  data() {
    return {
      showErrorMessage: false,
      code: this.$route.params.code.toString(),
    };
  },
  methods: {
    handleMessageClose() {
      this.showErrorMessage = false;
      this.$router.go(-1);
    },
  },
  mounted() {
    this.showErrorMessage = true;
  },
};
</script>
